export default "__VITE_ASSET__e4734423__"